import { useEffect } from 'react'
import useFetch from '../../hooks/useFetch'
import { urlApi } from '../../config'
import LoadingIndicator from '../../common/LoadingIndicator'

export function JoinCompanion({
  transaction,
  setJoinCompanion,
  setJoinCompanionAlert,
  setStatus,
  paymentMethod
}) {
  const { responseOk, loading } = useFetch(
    `${urlApi}/admin/lobbies/approve-transaction/${transaction._id}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ payment_method: paymentMethod })
    }
  )

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Acompañante unido')
        setStatus('approved')
      } else {
        alert('Error al unir acompañante')
      }
      setJoinCompanion(false)
      setJoinCompanionAlert(false)
    }
  }, [loading])

  return <LoadingIndicator size={30} />
}

export function VerifyUser({ setVerifyUser, userId }) {
  const { loading, responseOk } = useFetch(`${urlApi}/admin/users/verify/${userId}`, {
    method: 'POST'
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Usuario verificado')
      } else {
        alert('Error al verificar')
      }
      setVerifyUser(false)
    }
  }, [loading])

  return null
}

export function DeclineVerification({ setDeclineVerification, userId, reason }) {
  const { loading, responseOk } = useFetch(`${urlApi}/admin/users/decline-verification/${userId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason })
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Usuario rechazado')
      } else {
        alert('Error al rechazar')
      }
      setDeclineVerification(false)
    }
  }, [loading])

  return null
}

export function BlockUser({ setBlockUser, userId, handleSuccess }) {
  const { loading, responseOk } = useFetch(`${urlApi}/admin/users/block/${userId}`, {
    method: 'POST'
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Usuario bloqueado')
        handleSuccess()
      } else {
        alert('Error al bloquear')
      }
      setBlockUser(false)
    }
  }, [loading])

  return null
}

export function UnblockUser({ setUnblockUser, userId, handleSuccess }) {
  const { loading, responseOk } = useFetch(`${urlApi}/admin/users/unblock/${userId}`, {
    method: 'POST'
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Usuario desbloqueado')
        handleSuccess()
      } else {
        alert('Error al desbloquear')
      }
      setUnblockUser(false)
    }
  }, [loading])

  return null
}

export function SendComment({ setSendComment, userId, comment, handleSuccess }) {
  const { loading, responseOk } = useFetch(`${urlApi}/admin/users/comment/${userId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ comment })
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Comentario enviado')
        setSendComment(false)
        handleSuccess()
      } else {
        alert('Error al enviar comentario')
        setSendComment(false)
      }
    }
  }, [loading])

  return null
}

export function DeletePhoneNumber({ setDeletePhoneNumber, userId }) {
  const { loading, responseOk } = useFetch(`${urlApi}/admin/users/delete-phone-number/${userId}`, {
    method: 'PATCH'
  })

  useEffect(() => {
    if (!loading) {
      if (responseOk) {
        alert('Número de teléfono eliminado')
      } else {
        alert('Error al eliminar número de teléfono')
      }
      setDeletePhoneNumber(false)
    }
  }, [loading])

  return null
}
